import React, { FC } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { observer } from 'mobx-react'
import { IonContent, IonPage } from '@ionic/react'
import './index.scss'
import { Header } from '@cps'
import { storeMobx } from 'restaurant'
import MktController from '@ctrls/mktController'
import { useHistoryNew } from '@utils'

// interface
interface IProps extends IPage, RouteComponentProps {
  mapType?: string;
  locationOBJ: {
    latitude: string;
    longitude: string;
  };
}

/** 选择城市 */
const StoreCitys: FC<IProps> = (props) => {
  const { storeCityList } = storeMobx
  const history = useHistoryNew()
  const handleBack = (isSuccess?: boolean) => {
    if (history.getPrevState() === '/store' || !isSuccess) {
      history.goBack()
    } else {
      history.replace('/store')
    }
  }
  const handleSelectCity = (cityName: string) => {
    storeMobx.setStoreCity(cityName)
    handleBack(true)
  }
  return (
    <IonPage className='store-city-page'>
      <Header onBack={handleBack} />
      <IonContent className='store-city-content'>
        <div className='store-city-container'>
          <div className='store-title'>{i18n.t('store.allStoreCitys')}</div>
          <div className='store-list-wrapper'>
            {
              storeCityList.map((item, index) => (
                <div
                  className='store-item'
                  data-cypid={`store-city-item-${item}`}
                  key={item}
                  onClick={() => handleSelectCity(item)}
                >
                  <span>{item}</span>
                </div>
              ))
            }
          </div>
        </div>
      </IonContent>
    </IonPage>
  )
}

export default observer(StoreCitys)
